import itemsService from '../../services/items'
import categoriesService from '../../services/categories'
import menuItemsService from '../../services/menuitems'

const state = {
  itemsFromRepository: [],
  categoriesFromRepository: [],
  itemsInMenu : [],
  selectedItems : [],
  itemsSearch: []
}

// getters 
const getters = {
  getItemByIndex: (state) => (itemId) => {
    return state.itemsFromRepository
                .findIndex(item => item.itemId === itemId);
  },
  getItemById: (state) => (itemId) => {
    return state.itemsFromRepository
                .find(item => item.itemId === itemId);
  },
  getItemByCategory: (state) => (categoryId) => {
    return state.itemsFromRepository
                .find(item => item.categoryId === categoryId);
  }
}

// actions
const actions = {
    async getItemsFromRepositoryAction(context) {
        if ( state.itemsFromRepository.length === 0) {
            await itemsService.getItemsByRestaurant()
                      .then( data => { context.commit('setItemsFromRepositoryState', data)});
        }
    },
    async getCategoriesFromRepositoryAction(context) {
        if (state.categoriesFromRepository.length === 0) {
            await categoriesService.getCategoriesByRestaurant()
                           .then( data => { context.commit('setCategoriesFromRepositoryState', data) });
        }
    },
    async getMenuItemsAction(context, menuid) {
        await menuItemsService.getMenuItemsByMenu(menuid)
                              .then(data => { context.commit('setItemsInMenuState', data);
                                              context.commit('setSelectedItemsFromRepository'); });
    }
}

// mutations
const mutations = {
    setItemsFromRepositoryState(state, items) {
        items.forEach(i => {
            i.isChecked = false;
        })
        state.itemsFromRepository = items;
    },
    setCategoriesFromRepositoryState(state, categories) {
        state.categoriesFromRepository = categories;
    },
    addItemToSelectedItemsState(state, item) {
        let index = state.itemsFromRepository
                     .findIndex(i => i.itemId === item.itemId);
        if (index > -1) {
            state.items[index] = item;
        }
        state.items.push(item);
    },
    setItemsInMenuState(state, menuitems) {
        
        state.itemsInMenu = menuitems;
    },
    setSelectedItemsFromRepository(state) {
        state.itemsFromRepository.forEach(i => {
            let item = state.itemsInMenu.find(r => { return r.itemId === i.itemId });
            if (item != null) {
                i.isChecked = true;
            }
            else {
                i.isChecked = false;
            }
        });
    }
}

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations
}